import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { json, useRouteLoaderData} from "react-router-dom";
import UserItem from "./UserItem";
import { redirect } from "react-router-dom";
const UserDetails = () => {
    const userData = useRouteLoaderData('user-Info');
    return (
        <>
        <UserItem userInfo={userData}/>
        </>
    );
}

export default UserDetails;

export const loader = async ({params, request}) => {
    const id = params.UserId;
    const token = getAuthToken();
    if(token === null || token ==='EXPIRED'){
      return redirect('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/users/getUserByMobile?mobile=`;
    try {
      const response = await fetch(apiUrl + id, {
        method: request.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw json({ message:"could not fetch users"}, {status:500} );
      } else {
        return response;
      }
    } catch (error) {
      throw new Error("Failed to fetch users details.");
    }
  };

  
//   export async function action({params, request}) {
//     const userId = params.UserId;
//     const token = getAuthToken();
//     const apiChar = getApiChara();
//     const apiUrl = `${apiChar}/users/deleteUserByMobile/${userId}`;
//     const response = await fetch(apiUrl, {
//         method:request.method,
//         headers: {
//             'Authorization':'Bearer ' + token
//         }
//     });
//     if(!response.ok){
//         throw json({ message:"could not deleted"}, {status:500} );
//     } else {
//         const data = response;
//         return redirect('..');
//     }
//  }